// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router';
import nest from 'recompose/nest';
import { withTranslation } from 'react-i18next';

import TariffModal from 'app/components/Subs/TariffModal';
import TariffsList from 'app/components/Subs/TariffsList';
import withModal from 'app/common/containers/withModal';

import enhanceSubscribePlease from './enhanceSubscribePlease';


type ConnectLinkProps = {
  toggleModal: (e: SyntheticEvent<HTMLElement>) => void,
  t: (s: string, t: Object) => string,
  children: Node,
}
const ConnectLink = ({ toggleModal, children, t }: ConnectLinkProps) => (
  <span>
    <Link to="connect" onClick={toggleModal}>{t('passes:connect_link')}</Link>
    {children}
  </span>
);

// Модальное окно, включая ссылку для его открытия
const ConnectModal = withModal(nest(ConnectLink, TariffModal));

type Props = {
  className?: string,
  service: string,
  studentId: string,
  t: (s: string, t: Object) => string,
}
const SubscribePlease = ({ className, service, studentId, t }: Props) => {
  const appName = t(`subs:${service}`);

  return (
    <div className={className}>
      {t('passes:subscribe')}
      <ConnectModal
        title={t('passes:subscribe_title')}
        description={t('passes:subscribe_for_app', { appName })}
        t={t}
      >
        <TariffsList
          service={service}
          studentId={studentId}
          skipFetch
        />
      </ConnectModal>
      {'.'}
    </div>
  );
};

export default withTranslation()(enhanceSubscribePlease(SubscribePlease));
